import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useEmitTypingIndicator(): () => void {
  return useWebChatAPIContext().emitTypingIndicator;
}
